/* NON 1zu1 — Zustandslogik, übertragen aus dem <script type="text/x-dc">-Block
   der Canvas-Boards (Startseite, M-Startseite, M-Menue). Gleiche Zustände,
   gleiche Werte. Elemente tragen ihre Canvas-Vorlage in data-non-style
   ([[name]] statt {{name}}), render() setzt sie neu. */
(function () {
  var heights = { shop: 269, brand: 91, info: 91, suche: 90, konto: 49 };   // Brand/Info je 3 Einträge (Eray 08.10.)
  var foot = { shop: 160, sup: 206, legal: 206 };   // shop = Spalte „Brand“ (3 Links), Support 4 Links (Eray 08.10.)

  var state = {
    open: null, hovered: false,          // Desktop-Vorhang
    menu: false, suche: false,           // mobil
    foot: null,                          // Footer-Akkordeon mobil
    mm: null,                            // Mobilmenü Brand/Info
    mS: 'top', mWhite: false, mNoTr: false,  // Mobil-Leiste: oben / aus / weiß eingeblendet (LFDY)
    cartOpen: false, acct: false,        // Drawer
    sg: false, size: null,               // Größentabelle, gewählte Größe
    acc: 'desc',                         // Akkordeon Produktseite, Vorauswahl desc
    faq: null,                           // FAQ-Akkordeon, Vorauswahl keins
    btn: false, atc: false,              // Hover „In den Warenkorb“ Desktop/mobil
    btn4: false, btn5: false, btn6: false, chk: false, add: false, ord: false  // Button-Hover
  };

  var root = document.querySelector('[data-non-invert]');
  // Hell über dem Hero: Seiten mit dunklem Hero (About, FAQ, Kontakt) und die Startseite,
  // sobald dort ein Kampagnenbild/-video gesetzt ist (Eray 07.10.). Vorhang offen -> dunkel.
  var invert = (!!root && root.getAttribute('data-non-invert') === '1') || !!document.querySelector('[data-non-hell]');

  function vals() {
    var open = state.open, hovered = state.hovered;
    var light = invert && !hovered;
    var on = function (n) { return open === n ? 1 : 0; };
    var pe = function (n) { return open === n ? 'auto' : 'none'; };
    var v = {
      curtainH: hovered ? (60 + (open ? (heights[open] || 0) : 0)) : 0,
      fg: light ? '#FFFFFF' : '#0A0A0A',
      logoDark: light ? 0 : 1,
      logoLight: light ? 1 : 0,
      opShop: on('shop'), peShop: pe('shop'),
      opBrand: on('brand'), peBrand: pe('brand'),
      opInfo: on('info'), peInfo: pe('info'),
      opSuche: on('suche'), peSuche: pe('suche'),
      opKonto: on('konto'), peKonto: pe('konto'),
      kontoX: kontoX(),
      brandX: brandX(),
      fgInv: light ? '#0A0A0A' : '#FFFFFF',
      menuX: state.menu ? '0%' : '-100%',
      menuPe: state.menu ? 'auto' : 'none',
      sucheH: state.suche ? 60 : 0,
      sucheBd: state.suche ? '1px solid #E4E4E4' : 'none',
      cartX: state.cartOpen ? '0' : '100%',
      cartScrim: state.cartOpen ? 1 : 0,
      cartPe: state.cartOpen ? 'auto' : 'none',
      acctX: state.acct ? '0' : '100%',
      acctScrim: state.acct ? 1 : 0,
      acctPe: state.acct ? 'auto' : 'none',
      sgX: state.sg ? '0' : '100%'
    };
    ['S', 'M', 'L', 'XL'].forEach(function (g) {
      v['row' + g] = state.size === g ? '#EFEFEF' : 'transparent';
      v['sz' + g + 'Bg'] = state.size === g ? '#0A0A0A' : '#FFFFFF';
      v['sz' + g + 'Fg'] = state.size === g ? '#FFFFFF' : '#0A0A0A';
      v['sz' + g + 'Bd'] = state.size === g ? '#0A0A0A' : '#C4C4C4';
    });
    // Produktseite: Akkordeon (Desktop accH aus canvas/Produktseite, mobil heights aus M-Produktseite)
    var accD = { Desc: 237, Fit: 82, Ship: 236, Sup: 92 }, accM = { desc: 290, fit: 100, ship: 190, sup: 100 };
    Object.keys(accD).forEach(function (K) {
      var k = K.toLowerCase(), on = state.acc === k;
      v['h' + K] = on ? hoehe(K) : 0; v['s' + K] = on ? '−' : '+';
      v['w' + K] = on ? 700 : 400;   // offene Überschrift fett (LFDY)
      v['h' + k] = on ? hoeheM(k) : 0; v['w' + k] = on ? 700 : 400; v['s' + k] = on ? '−' : '+'; v['b' + k] = on ? '1px solid #0A0A0A' : 'none';
    });
    // FAQ: Höhen aus canvas/FAQ (faqH) und M-FAQ (heights.faqN)
    var faqD = [78, 104, 52, 78, 78, 78, 78, 78, 78, 78], faqM = [118, 118, 72, 95, 118, 118, 95, 118, 95, 95];
    for (var f = 0; f < 10; f++) {
      v['hFaq' + f] = state.faq === f ? faqD[f] : 0;
      v['hFaqm' + f] = state.faq === f ? faqM[f] : 0;
      v['sFaq' + f] = state.faq === f ? '−' : '+';
    }
    v.btnBg = state.btn ? '#157F3C' : '#0A0A0A';
    v.atcBg = state.atc ? '#157F3C' : '#0A0A0A';
    var vv = variante();
    v.bestand = !vv ? (state.hinweis ? 'Bitte wähle eine Größe.' : '') : (!vv.verfuegbar ? 'Größe ' + state.size + ' ist ausverkauft.' : '');
    ['shop', 'sup', 'legal'].forEach(function (k) {
      v['f' + k] = state.foot === k ? '−' : '+';
      v['fh' + k] = state.foot === k ? hoeheF(k) : 0;
      v['fb' + k] = state.foot === k ? '1px solid #0A0A0A' : 'none';
    });
    // Größentabelle: cm / inch (Eray 13.10.)
    v.cmD = state.inch ? 'none' : 'inline'; v.inD = state.inch ? 'inline' : 'none';
    v.cmB = state.inch ? '1px solid #E4E4E4' : '2px solid #0A0A0A'; v.cmC = state.inch ? '#9A9A9A' : '#0A0A0A';
    v.inB = state.inch ? '2px solid #0A0A0A' : '1px solid #E4E4E4'; v.inC = state.inch ? '#0A0A0A' : '#9A9A9A';
    // Mobil-Leiste: oben transparent über dem Hero, beim Hochscrollen fest und weiß
    var mbar = document.querySelector('[data-non-mbar]');
    var mov = !!mbar && mbar.getAttribute('data-non-mbar') === '1';
    var mw = !mov || state.suche || state.mS === 'show' || (state.mS === 'hide' && state.mWhite);
    v.mbPos = state.mS === 'top' ? 'absolute' : 'fixed';
    v.mbY = state.mS === 'hide' ? '-100%' : '0';
    v.mbTr = state.mNoTr ? 'none' : 'transform .3s ease';
    v.mbBg = mw ? '#FFFFFF' : 'transparent';
    v.mbFg = mw ? '#0A0A0A' : '#FFFFFF';
    v.mbBadge = mw ? '#FFFFFF' : '#0A0A0A';
    v.mlB = mw ? 'block' : 'none';
    v.mlW = mw ? 'none' : 'block';
    // Mobilmenü: Brand als Unterpanel von rechts (LFDY)
    v.msubX = state.mm === 'brand' ? '0%' : '100%';
    v.msubPe = state.mm === 'brand' ? 'auto' : 'none';
    ['4', '5', '6'].forEach(function (n) { v['btnBg' + n] = state['btn' + n] ? '#157F3C' : '#0A0A0A'; });
    ['chk', 'add', 'ord'].forEach(function (k) { v[k + 'Bg'] = state[k] ? '#157F3C' : '#0A0A0A'; });
    return v;
  }

  // Varianten der Produktseite (aus sections/non-produkt.liquid)
  var VAR = null;
  try { var j = document.querySelector('[data-non-varianten]'); if (j) VAR = JSON.parse(j.textContent); } catch (e) {}
  function variante() {
    if (!VAR) return null;
    for (var i = 0; i < VAR.varianten.length; i++) if (VAR.varianten[i].groesse === state.size) return VAR.varianten[i];
    return null;
  }

  // Einzug „Meine Bestellung“ = linke Kante des Menüpunkts „Konto“ (Canvas: 1186px bei 1440px)
  function kontoX() {
    var k = document.querySelector('[data-on-mouseenter="overKonto"] a');
    if (!k || !k.offsetParent) return 1186;
    return Math.round(k.getBoundingClientRect().left);
  }

  function brandX() {
    var k = document.querySelector('[data-on-mouseenter="overBrand"] a');
    if (!k || !k.offsetParent) return 63;
    return Math.round(k.getBoundingClientRect().left);
  }

  // Footer-Akkordeon mobil: Höhe = gemessener Inhalt (LFDY-Schrift, Eray 09.10.)
  function hoeheF(k) {
    var el = document.querySelector('[data-non-style*="[[fh' + k + ']]"]');
    return el && el.firstElementChild ? el.firstElementChild.offsetHeight : 0;
  }

  // Akkordeon Produktseite mobil: Höhe = gemessener Inhalt (LFDY-Schrift 12px, Eray 09.10.)
  function hoeheM(k) {
    var el = document.querySelector('[data-non-style*="[[h' + k + ']]"]');
    return el && el.firstElementChild ? el.firstElementChild.offsetHeight : 0;
  }

  // Akkordeon Produktseite Desktop: Höhe = gemessener Inhalt (Text nach LFDY verkleinert, Eray 08.10.)
  function hoehe(K) {
    var el = document.querySelector('[data-non-style*="[[h' + K + ']]"]');
    return el && el.firstElementChild ? el.firstElementChild.offsetHeight : 0;
  }

  function render() {
    var v = vals();
    var fill = function (t) { return t.replace(/\[\[(\w+)\]\]/g, function (m, k) { return k in v ? v[k] : ''; }); };
    document.querySelectorAll('[data-non-style]').forEach(function (el) {
      el.setAttribute('style', fill(el.getAttribute('data-non-style')));
    });
    document.querySelectorAll('[data-non-text]').forEach(function (el) {
      var k = el.getAttribute('data-non-text');
      if (k in v) el.textContent = v[k];
    });
  }

  function set(p) { for (var k in p) state[k] = p[k]; render(); }
  function enter(name) { if (state.open !== name || !state.hovered) set({ open: name, hovered: true }); }

  var H = {
    overShop: function () { enter('shop'); },
    overBrand: function () { enter('brand'); },
    overInfo: function () { enter('info'); },
    overKonto: function () { enter('konto'); },
    enterBar: function () { enter(null); },
    leave: function () { set({ open: null, hovered: false }); },
    toggleSearch: function () {
      var willOpen = state.open !== 'suche';
      set({ open: willOpen ? 'suche' : null, hovered: true });
      if (willOpen) setTimeout(function () {
        var el = document.getElementById('q-start');
        if (el && el.focus) el.focus();
      }, 80);
    },
    openMenu: function () { set({ menu: true, mm: null }); },
    closeMenu: function () { set({ menu: false }); },
    toggleSuche: function () { set({ suche: !state.suche }); },
    tFootshop: function () { set({ foot: state.foot === 'shop' ? null : 'shop' }); },
    tFootsup: function () { set({ foot: state.foot === 'sup' ? null : 'sup' }); },
    tFootlegal: function () { set({ foot: state.foot === 'legal' ? null : 'legal' }); },
    tMenubrand: function () { set({ mm: state.mm === 'brand' ? null : 'brand' }); },
    tMenuinfo: function () { set({ mm: state.mm === 'info' ? null : 'info' }); },
    openCart: function () { set({ cartOpen: true, open: null }); },
    closeCart: function () { set({ cartOpen: false }); },
    openAcct: function () { set({ acct: true, open: null, menu: false }); },
    closeAcct: function () { set({ acct: false }); },
    openSg: function () { set({ sg: true }); },
    unitCm: function () { set({ inch: false }); },
    unitInch: function () { set({ inch: true }); },
    closeSg: function () { set({ sg: false }); },
    btnOver: function () { set({ btn: true }); }, btnOut: function () { set({ btn: false }); },
    atcOver: function () { set({ atc: true }); }, atcOut: function () { set({ atc: false }); }
  };
  for (var f = 0; f < 10; f++) (function (n) { H['tFaq' + n] = function () { set({ faq: state.faq === n ? null : n }); }; })(f);
  ['Desc', 'Fit', 'Ship', 'Sup'].forEach(function (K) {
    var k = K.toLowerCase();
    H['t' + K] = H['t' + k] = function () { set({ acc: state.acc === k ? null : k }); };
  });
  ['S', 'M', 'L', 'XL'].forEach(function (g) {
    H['pick' + g] = function () {
      set({ size: g });
      var vv = variante();
      if (vv) {
        document.querySelectorAll('[data-non-preis]').forEach(function (el) { el.textContent = vv.preis; });
        if (history.replaceState) history.replaceState(null, '', location.pathname + '?variant=' + vv.id);
      }
    };
  });
  // Hover je Button: btnOver4/btnOut4 … (Desktop), chkOver/chkOut … (mobil)
  ['4', '5', '6'].forEach(function (n) {
    H['btnOver' + n] = function () { var p = {}; p['btn' + n] = true; set(p); };
    H['btnOut' + n] = function () { var p = {}; p['btn' + n] = false; set(p); };
  });
  ['chk', 'add', 'ord'].forEach(function (k) {
    H[k + 'Over'] = function () { var p = {}; p[k] = true; set(p); };
    H[k + 'Out'] = function () { var p = {}; p[k] = false; set(p); };
  });

  function bind(scope) {
    ['mouseenter', 'mouseleave', 'click'].forEach(function (ev) {
      scope.querySelectorAll('[data-on-' + ev + ']').forEach(function (el) {
        var fn = H[el.getAttribute('data-on-' + ev)];
        if (fn) el.addEventListener(ev, fn);
      });
    });
  }
  bind(document);
  var breite = window.innerWidth;   // nur Breite zählt (Einzug „Meine Bestellung“)
  window.addEventListener('resize', function () { if (window.innerWidth !== breite) { breite = window.innerWidth; render(); } });

  // ---- Warenkorb: Shopify-Cart-API, danach nur den Drawer-Inhalt neu setzen ----
  var swap = document.querySelector('[data-non-swap]');
  var secEl = swap && swap.closest('[id^="shopify-section-"]');
  var secId = secEl ? secEl.id.replace('shopify-section-', '') : null;

  function aktualisieren(html) {
    var neu = new DOMParser().parseFromString(html, 'text/html');
    document.querySelectorAll('[data-non-swap]').forEach(function (el) {
      var n = neu.querySelector('[data-non-swap="' + el.getAttribute('data-non-swap') + '"]');
      if (n) { el.innerHTML = n.innerHTML; bind(el); }
    });
    ['data-non-cartlabel', 'data-non-count'].forEach(function (a) {
      var quelle = neu.querySelectorAll('[' + a + ']');
      document.querySelectorAll('[' + a + ']').forEach(function (el, i) {
        if (quelle[i]) el.textContent = quelle[i].textContent;
      });
    });
    render();
  }

  function post(url, body) {
    if (secId) body.sections = secId;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d.sections && d.sections[secId]) aktualisieren(d.sections[secId]);
      return d;
    });
  }

  function add(variantId, menge) {
    return post('/cart/add.js', { items: [{ id: Number(variantId), quantity: menge || 1 }] })
      .then(function (d) { set({ cartOpen: true, open: null }); return d; });
  }

  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-non-menge]');
    if (m) {
      e.preventDefault();
      post('/cart/change.js', { id: m.getAttribute('data-non-menge'), quantity: Number(m.getAttribute('data-q')) });
      return;
    }
    var a = e.target.closest('[data-non-add]');
    if (a) { e.preventDefault(); add(a.getAttribute('data-non-add'), 1); }
  });

  // Produktseite: keine Vorauswahl (Eray 07.10.) — nur die Größe aus ?variant= ist vorausgewählt
  if (VAR) {
    state.size = VAR.auswahl || null; render();
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-non-kaufen]')) return;
      var vv = variante();
      if (!vv) { set({ hinweis: true }); return; }
      if (vv.verfuegbar) add(vv.id, 1);
    });
  }
  // Galerie mobil: Punkte folgen dem Wischen
  document.querySelectorAll('[data-non-galerie]').forEach(function (g) {
    var punkte = g.parentNode.querySelectorAll('[data-non-punkt]');
    g.addEventListener('scroll', function () {
      var i = Math.round(g.scrollLeft / g.clientWidth);
      punkte.forEach(function (p, n) { p.style.background = n === i ? '#0A0A0A' : '#C8C8C8'; });
    }, { passive: true });
  });

  // Mobil-Leiste: runterscrollen blendet aus, hochscrollen blendet weiß ein (LFDY)
  if (document.querySelector('[data-non-mbar]')) {
    var lastY = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY, s = state.mS;
      if (window.innerWidth >= 750 || state.menu) { lastY = y; return; }
      if (y <= 30) s = 'top';
      else if (y > lastY + 2 && !state.suche) s = 'hide';
      else if (y < lastY - 2) s = 'show';
      if (s !== state.mS) {
        set({ mS: s, mWhite: s === 'show' ? true : (s === 'top' ? false : state.mWhite), mNoTr: state.mS === 'top' && y > 84 });
      }
      if (Math.abs(y - lastY) > 2) lastY = y;
    }, { passive: true });
  }

  // Inhaltsverzeichnis: weich zum Abschnitt scrollen (canvas scrollToId)
  document.addEventListener('click', function (e) {
    var j = e.target.closest('[data-non-jump]');
    if (!j) return;
    var el = document.getElementById(j.getAttribute('data-non-jump'));
    if (el && el.scrollIntoView) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });

  // Canvas „Warenkorb“: die Warenkorbseite ist der geöffnete Drawer
  if (/\/cart\/?$/.test(location.pathname)) set({ cartOpen: true });

  if (invert) render();

  window.NON = { state: state, set: set, render: render, add: add };
})();
